import { V3Record } from 'data/helpers/V3Record.js'
import { capitalize } from 'lib/utils'

export const CollectionItem = V3Record('collectionItem', {
  collectionId: null, // integer
  itemId: null, // integer
  itemType: null, // string
  position: null // integer
})

// we want to keep itemType lowercased in redux, but rails wants it capitalized
// for the polymorphic association
const _defaultDeserialize = CollectionItem.deserialize
const _defaultSerialize = CollectionItem.serialize
CollectionItem.deserialize = (...args) => {
  const item = _defaultDeserialize(...args)
  return item.set('itemType', item.itemType.toLowerCase())
}

// reverse the above operation
CollectionItem.serialize = (record, ...rest) => {
  const response = _defaultSerialize(record, ...rest)
  response.collection_item.item_type = capitalize(record.itemType)
  return response
}
